export const getAssetUrl = (path: string) => {
  if (!path) {
    return '';
  }
  // Keep selected local avatar assets local to avoid CDN propagation delay/broken links.
  if (
    path.startsWith('/assets/tutor-series-v4/')
    || path.startsWith('/assets/tutor-series-v5/')
    || path.startsWith('/assets/tutor-series-v6/')
  ) {
    return path;
  }
  // 判断是否已经添加了https://syllabus-cdn.pengi.ai/
  if (path.startsWith('https:')) {
    return path;
  }
  // path如果是以/开头，则去掉/
  if (path.startsWith('/')) {
    path = path.slice(1);
  }

  return `https://syllabus-cdn.pengi.ai/${path}`;
};
